import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { HelpCircle } from 'lucide-react';
const faqs = [{
  q: '¿Necesito potenciómetro o tecnología cara para aplicar el método?',
  a: 'No. El método fue diseñado específicamente para el ciclista amateur argentino sin dispositivos de gama alta. Todo lo que necesitás es la bici que ya tenés.'
}, {
  q: '¿Cómo recibo el material?',
  a: 'Inmediatamente después de la compra recibís acceso a todos los tomos y bonos en formato PDF. En menos de 5 minutos ya lo tenés disponible.'
}, {
  q: '¿Puedo imprimirlo?',
  a: 'Sí. Todos los tomos y bonos incluyen versión imprimible lista para usar.'
}, {
  q: '¿Sirve si ya llevo años pedaleando?',
  a: 'Sí. De hecho los ciclistas con más años encima son los que más se benefician porque ya tienen base y solo necesitan estructurar el entrenamiento.'
}, {
  q: '¿Tiene garantía real?',
  a: 'Sí. 7 días de devolución del 100% sin preguntas ni formularios.'
}];
export function FAQSection() {
  return <section className="py-12 md:py-16 px-4 bg-slate-950" data-id="element-105">
      <div className="max-w-3xl mx-auto" data-id="element-106">
        <FadeIn className="text-center mb-8" data-id="element-107">
          <HelpCircle className="w-9 h-9 text-amber-500 mx-auto mb-3" data-id="element-108" />
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white tracking-wide" data-id="element-109">
            ❓ LO QUE MÁS NOS PREGUNTAN
          </h2>
        </FadeIn>

        <div className="space-y-6" data-id="element-110">
          {faqs.map((faq, i) => <FadeIn key={i} delay={i * 0.1} data-id="element-111">
              <div className="bg-slate-900 border border-slate-800 rounded-2xl p-6 md:p-8" data-id="element-112">
                <h3 className="text-lg md:text-xl font-bold text-white mb-3" data-id="element-113">
                  {faq.q}
                </h3>
                <p className="text-slate-400 leading-relaxed" data-id="element-114">{faq.a}</p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}